import * as angular from 'angular';
import { PagamentosService } from './pagamentos.service';

export const PagamentosPontoListRouting = [
	'$stateProvider',
	function ($stateProvider: angular.ui.IStateProvider): void {
		let resolve = {
			'entity': [
				'PagamentosService',
				'$stateParams',
				'$state',
				'$q',
				function (
					entityService: PagamentosService,
					$stateParams: angular.ui.IStateParamsService,
					$state: angular.ui.IStateService,
					$q: angular.IQService
				): angular.ui.IStateParamsService | angular.IQService | {} {
					if ($stateParams['entity']) {
						return $stateParams['entity'];
					}

					if (!$stateParams['solicitacao']) {
						return {};
					}

					return $q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
						entityService.get($stateParams['solicitacao'])
							.then((data: unknown): void => {
								resolve(data);
							})
							.catch((error: any): void => {
								if (error.status === 404) {
									if ($state.href('ferias_marcacoes_not_found', $stateParams)) {
										$state.go('ferias_marcacoes_not_found', $stateParams);
									} else {
										$state.go('not_found', $stateParams);
									}
								}
							});
					});
				}
			]
		};

		$stateProvider
			.state('pagamentosponto', {
				url: '/ponto/pagamentos?q?situacao?estabelecimento?apuracaoponto',
				template: require('html-loader!./index/pagamentos.index.html'),
				controller: 'PagamentosPontoIndexController',
				controllerAs: 'mrh_pgmts_lst_cntrllr',
				reloadOnSearch: false
			});
	}
];
